import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import styles from './Notification.module.scss'
import { ROUTES } from 'routes/paths'

const NoEmailNotification = ({ email, onPress, pathname }) => {
  const { t } = useTranslation()

  return (
    <>
      <span className={styles.addSpaceEnd}>
        {t(
          'Te hemos enviado un correo electrónico a, {{email}} para que valides tu cuenta Si no lo has recibido, te lo volvemos a',
          { email }
        )}
      </span>
      <a
        className={`${styles.addPointEnd} ${styles.link}`}
        onClick={onPress}
        role='link'
      >
        {t('enviar')}
      </a>
      {pathname !== ROUTES.ACCOUNT && (
        <>
          <span className={`${styles.addSpaceStart} ${styles.addSpaceEnd}`}>
            {t('Puedes cambiar tu correo electrónico')}
          </span>
          <Link to={ROUTES.ACCOUNT}>
            <span className={`${styles.addPointEnd} ${styles.link}`}>
              {t('aquí')}
            </span>
          </Link>
        </>
      )}
    </>
  )
}

NoEmailNotification.defaultProps = {
  pathname: null,
}

NoEmailNotification.propTypes = {
  email: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  pathname: PropTypes.string,
}

export default NoEmailNotification
